import { render, staticRenderFns } from "./VoteList.vue?vue&type=template&id=f7941ad0&scoped=true&"
import script from "./VoteList.vue?vue&type=script&lang=ts&"
export * from "./VoteList.vue?vue&type=script&lang=ts&"
import style0 from "./VoteList.vue?vue&type=style&index=0&id=f7941ad0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7941ad0",
  null
  
)

export default component.exports